import { render, staticRenderFns } from "./managePayees.vue?vue&type=template&id=e70dfede"
import script from "./managePayees.vue?vue&type=script&lang=js"
export * from "./managePayees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e70dfede')) {
      api.createRecord('e70dfede', component.options)
    } else {
      api.reload('e70dfede', component.options)
    }
    module.hot.accept("./managePayees.vue?vue&type=template&id=e70dfede", function () {
      api.rerender('e70dfede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/managePayees.vue"
export default component.exports